export default "__VITE_ASSET__82d1c121__"